import Header from '../../organisms/Header/Header'
import technologyhero from '../../../assets/images/technology/technologyhero.svg'
import colors from '../../theme/color'
import CommonHeroSection from '../../organisms/commonherosection/CommonHeroSection'

const TechnologyHero = () => {
  return (
    <CommonHeroSection>
      {/* Header */}
      <div className="relative">
        <Header />
      </div>

      {/* Content */}
      <div className="relative z-10 flex min-h-[65vh] flex-col items-center justify-center gap-7 px-6 py-10 md:min-h-[75vh] md:gap-10 md:px-10 md:py-12 lg:flex-row lg:gap-5 lg:px-15">

        {/* TEXT */}
        <div className="order-1 w-full max-w-7xl text-center lg:text-left lg:order-1 2xl:pl-[5%]">

          {/* HEADING */}
          <h1 className="font-rajdhani text-3xl font-bold leading-tight text-white sm:text-4xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl">
            Technology Chosen for Your Success, Not Our Convenience
          </h1>

          {/* MOBILE + TABLET IMAGE */}
          <div className="my-8 flex w-full justify-center lg:hidden">
            <img
              src={technologyhero}
              alt="technology visual"
              className="h-[220px] w-auto object-contain sm:h-[280px] md:h-[360px]"
            />
          </div>

          {/* PARAGRAPH */}
          <p className="font-gilroy-medium text-base leading-relaxed text-gray-400 sm:text-lg md:text-xl lg:mt-6 lg:text-xl xl:text-3xl 2xl:text-4xl 2xl:leading-tight">
            We invest continuously in our technical capabilities. Our stack
            choices are driven by project requirements, not trends, balancing
            innovation with stability.
          </p>
        </div>

        {/* LAPTOP IMAGE */}
        <div className="hidden w-full justify-center lg:order-2 lg:flex">
          <img
            src={technologyhero}
            alt="technology visual"
            className="h-[480px] w-auto object-contain xl:h-[550px] 2xl:h-[680px]"
          />
        </div>
      </div>

      {/* Bottom Line */}
      <div
        className="pointer-events-none absolute bottom-0 left-0 z-20 h-[4px] w-full"
        style={{ backgroundColor: colors.purple }}
      />
    </CommonHeroSection>
  )
}

export default TechnologyHero